export default "__VITE_ASSET__DmYbZV43__"